import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SignatureDeclineButtonWithRedux } from 'SignatureDeclineButton';

const StaticBuilderSaveButton = (props) => {
  if (props.isHidden) {
    return null;
  }

  const signButtonClassNames = classNames(
    'pull-right btn btn-large btn-success saveButton',
    {
      disabled: !props.isSignatureAdded,
    },
  );

  if (props.showSignButton) {
    return (
      <div className="static-builder-sign-buttons">
        {props.isSelfServe && !props.isPreviewMode && (
          <SignatureDeclineButtonWithRedux
            confirmationTracking="Sign Decline"
            documentType={props.documentType}
            shareKey={props.shareKey}
            useWhiteText={false}
          />
        )}
        <button
          type="button"
          onClick={props.onSign}
          data-loading-text="Saving..."
          data-finishing-text="Finishing..."
          className={signButtonClassNames}
        >
          Sign
        </button>
      </div>
    );
  }
  return (
    <button
      type="button"
      onClick={props.clickNextButton}
      data-loading-text="Saving..."
      data-finishing-text="Finishing..."
      className="pull-right btn btn-large btn-success saveButton"
      id="staticSaveButton"
    >
      {props.buttonContent}
    </button>
  );
};

StaticBuilderSaveButton.defaultProps = {
  isPreviewMode: false,
  isSelfServe: false,
  shareKey: '',
};

StaticBuilderSaveButton.propTypes = {
  buttonContent: PropTypes.string.isRequired,
  clickNextButton: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
  isHidden: PropTypes.bool.isRequired,
  isPreviewMode: PropTypes.bool,
  isSelfServe: PropTypes.bool,
  isSignatureAdded: PropTypes.bool.isRequired,
  onSign: PropTypes.func.isRequired,
  shareKey: PropTypes.string,
  showSignButton: PropTypes.bool.isRequired,
};

export default StaticBuilderSaveButton;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderSaveButton.jsx